export default __webpack_public_path__ + "static/media/videoThumb.cda37a05.png";